import logger from '@/modules/Logger';

export default {
  // enable/disable screen share
  async shareScreen(mode) {
    this.constraints.video = !mode;
    this.constraints.screen = mode;

    try {
      // Disable VB processor before screen share to prevent blur on any track
      if (mode && this.videoEffect !== 'none') {
        try {
          await this.vbProcessor.disable();
        } catch (error) {
          logger.error('[Agora] Failed to disable VB before screen share', {
            operation: 'vbackground:screen-share',
            reason: error.message
          });
        }
      }

      this.filterVideoTrack();

      if (mode) {
        // moving this to another method produces an error on safari
        await this.createScreenTracks();

        logger.info(
          this.localScreenAudioTrack
            ? 'Screen share started with audio track'
            : 'Screen share started without audio track',
          { operation: 'webrtc:share-screen', lesson_id: this.lessonId }
        );
      }
      const stream = await this.publishTracks();

      // Re-enable VB processor after stopping screen share
      if (!mode && this.videoEffect !== 'none' && this.vbProcessorReady) {
        try {
          await this.vbProcessor.enable();
        } catch (error) {
          logger.error('[Agora] Failed to re-enable VB after screen share', {
            operation: 'vbackground:screen-share',
            reason: error.message
          });
        }
      }

      return { stream };
    } catch (error) {
      this.constraints.screen = false;
      return { error };
    }
  }
}
